import { useFormatMessageGeneric } from '@main/core-ui/src/GenericFormattedMessage';
import { ColorPalette } from '@main/theme';
import React from 'react';
import { useTheme } from 'styled-components';

import { Badge } from '../Badge';
import { Icon, IconType } from '../Icon';
import { LoadingSpinner } from '../LoadingSpinner';
import { SideMenuTabProps } from './types';
import { MaxLengthWrapper, TabWrapper } from './wrappers';

/**
 * Render a side menu tab
 */
export const SideMenuTab: React.FC<SideMenuTabProps> = ({
  tab: { logo, loading, count, title },
  values,
  style,
}) => {
  const { formatMessageGeneric } = useFormatMessageGeneric();
  const theme = useTheme();
  return (
    <TabWrapper style={style}>
      {logo &&
        (typeof logo === 'object' ? (
          <Icon
            type={logo.logo as IconType}
            color={
              logo.color
                ? theme.colors[logo.color as keyof ColorPalette]
                : undefined
            }
            size={logo.height}
          />
        ) : (
          <Icon type={logo as IconType} size={20} />
        ))}
      <MaxLengthWrapper>
        {title ? formatMessageGeneric(title, values) : undefined}
      </MaxLengthWrapper>
      {loading && <LoadingSpinner small />}
      {count && count > 0 ? (
        <Badge color="transcendNavy4">{count}</Badge>
      ) : undefined}
    </TabWrapper>
  );
};
